import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as resetPasswordActions from './../ResetPassword/resetPasswordActions'; 

import Aux from './../../hoc/_Aux';

import { generateInputControls, onChangedHandler, generateForm } from './../../utils/form/generateFormTools';
import { validate } from './../../utils/form/validation';

class ResetPasswordForm extends Component {

    // defines inputs that belongs to the current form 
    elementsForForm = {
        password:{
            labelPosition: 'right',
            placeholder: 'mot de passe',
            defaultValue: '' 
        },
        password_confirm:{
            labelPosition: 'left',
            placeholder: 'confirme mot de passe',
            defaultValue: ''
        },
        submit: {
            defaultValue: 'C\'est parti' //submit needs value instead of label
        }
    };

    state = {
        controls: generateInputControls(['password', 'password_confirm', 'submit'], this.elementsForForm)
    }

    // routine legacy from generateFormTools.js
    inputChangedHandler = onChangedHandler;

    getParams = (queryString) => {

        var params = {};
        queryString = queryString.substr(1);
        var arrayOfParams = queryString.split("&");
        var arrayTmp = []
        for (var i=0; i<arrayOfParams.length; i++ )
        {
            arrayTmp = arrayOfParams[i].split("=");
            params[arrayTmp[0]] = arrayTmp[1];
        }

        return params;
    }
    

    submitHandler = ( event ) => {
        event.preventDefault();

        let FormIsValid = true;
        const updatedControls = {...this.state.controls};
        
        for (let controlName in this.state.controls) {
            const controlElement = this.state.controls[controlName];

            // if form element are invalid and there is no error message set on the field, we update controls accordingly    
            if(controlElement.valid===false){
                
                FormIsValid = false; 
                if(controlElement.errorMessage===''){
                    const validation = validate( controlElement.value, controlElement.validation ); 
                
                    if(!validation['isValid']){
                        FormIsValid = false;
                        updatedControls[controlName] = {
                            ...this.state.controls[controlName],
                            valid: validation['isValid'],
                            errorMessage: validation['errorMessage'],
                            touched: true
                        };

                    }
                }
            }   
        }

        if(FormIsValid){
            var params = this.getParams(this.props.query);
            this.props.onResetPassword(params.id, params.tim, params.ct, this.state.controls.password.value, this.state.controls.password_confirm.value);
        }
        else if(this.state.controls.password.value === '')
        {
            this.props.onError('Hey ! Tu as oublié d\'écrire ton mot de passe');
        }
        else if (this.state.controls.password_confirm.value === '')
        {
            this.props.onError('Hey ! Tu as oublié de confirmer ton mot de passe');
        }
        else {
            this.props.onError(this.state.controls.password.errorMessage);
        }

    }

    render(){
        let form = generateForm(this, this.state.controls);

        return (
            <Aux>
                <form onSubmit={this.submitHandler} name={this.props.name} className={this.props.class}>
                    {form}
                </form>
            </Aux>
        );
    }
}

const mapStateToProps = state => {
    return {
        hasError: state.auth.hasError,
        errorMessage: state.auth.errorMessage
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onResetPassword: ( id, tim, ct, password, passwordConfirm) => dispatch( resetPasswordActions.updatePassword( id, tim, ct, password, passwordConfirm) ),
        onError: (errorMessage) => dispatch(resetPasswordActions.error(errorMessage))
    };
};

export default connect( mapStateToProps, mapDispatchToProps )(ResetPasswordForm);


// WEBPACK FOOTER //
// ./src/components/forms/resetPasswordForm.js